import React from 'react';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@material-ui/core';
import { get } from 'lodash';
import { IntlShape, injectIntl } from 'react-intl';
import { TUTOR } from 'containers/data-structure';
import { Grid } from '@material-ui/core';
import { displayErrorText } from 'containers/services/validateForm';
import { arrayTranslate } from 'containers/services/translate';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import CloseIcon from '@material-ui/icons/Close';
import { StyledDialog } from 'components/InvoiceFeeNoteDialog/styles';
import { translate } from 'containers/services/translate';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import messages from 'containers/TransactionManagerTimeLine/OfferRegulation/messages';
import { tutorValidator } from 'containers/TransactionManagerTimeLine/OfferRegulation/utils';

export interface TutorInfoDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  handleValidate: Function;
  transactionId: number;
  claimId: number;
  victimId: number | null;
}

const TutorInfoDialog: React.FC<TutorInfoDialogProps> = (
  props,
): JSX.Element => {
  const { onClose, open } = props;
  const [tutorInfo, setTutorInfo] = React.useState<any>({});
  const [tutorValidation, setTutorValidation] = React.useState({});

  const handleClose = () => {
    onClose(false);
  };
  const handleChangeTutorInfo = (field: string) => (
    event: React.ChangeEvent<{
      name?: string;
      value?: any;
    }>,
    valueField?: any,
  ) => {
    const { value } = event.target;

    switch (field) {
      case TUTOR.CIN:
        tutorInfo[TUTOR.CIN] = value;
        break;
      case TUTOR.LAST_NAME:
        tutorInfo[TUTOR.LAST_NAME] = value;
        break;
      case TUTOR.FIRST_NAME:
        tutorInfo[TUTOR.FIRST_NAME] = value;
        break;

      default:
        return tutorInfo;
    }

    setTutorInfo({ ...tutorInfo });
  };
  const translateArrayErrorMessages = arrayTranslate(props.intl.formatMessage);
  const validator = tutorValidator(tutorInfo) || {};
  const handleValidate = () => {
    setTutorValidation(validator);
    props.handleValidate({
      tutorInfo: {
        ...tutorInfo,
        transactionId: props.transactionId,
        victimId: props.victimId,
      },
      isTrackingActive: featureService.hasFeature(
        FEATURES.TRACKING_ACTIONS_USER,
      ),
      claimId: props.claimId,
    });
  };

  const { message } = displayErrorText(
    tutorValidation,
    translateArrayErrorMessages(tutorValidation, true),
  );
  return (
    <StyledDialog onClose={handleClose} open={open}>
      <DialogTitle>
        <Grid
          container
          direction="row"
          alignItems="center"
          justify="space-between"
        >
          <Grid item xs={9}>
            <span
              style={{
                color: '#172C51 !important',
                fontSize: '20px',
                lineHeight: '24.42px',
              }}
            >
              {translate(messages.tutor, props)}
            </span>
          </Grid>
          <Grid item>
            <CloseIcon onClick={handleClose} />
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent>
        <Grid container direction="row" spacing={1}>
          <Grid item xs={6}>
            <TextField
              label={translate({ ...messages.victimCin }, props)}
              className="input"
              name={TUTOR.CIN}
              fullWidth
              value={get(tutorInfo, [TUTOR.CIN])}
              onChange={handleChangeTutorInfo(TUTOR.CIN)}
              InputProps={{ inputProps: { maxlength: 20 } }}
              error={message[TUTOR.CIN]}
              helperText={message[TUTOR.CIN]}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label={translate({ ...messages.victimLastName }, props)}
              className="input"
              name={TUTOR.LAST_NAME}
              fullWidth
              value={get(tutorInfo, [TUTOR.LAST_NAME])}
              onChange={handleChangeTutorInfo(TUTOR.LAST_NAME)}
              error={message[TUTOR.LAST_NAME]}
              helperText={message[TUTOR.LAST_NAME]}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label={translate({ ...messages.victimFirstName }, props)}
              className="input"
              fullWidth
              name={TUTOR.FIRST_NAME}
              value={get(tutorInfo, [TUTOR.FIRST_NAME])}
              onChange={handleChangeTutorInfo(TUTOR.FIRST_NAME)}
              error={message[TUTOR.FIRST_NAME]}
              helperText={message[TUTOR.FIRST_NAME]}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className="success-actions">
        <SecondaryButton
          onClick={() => props.onClose()}
          disableElevation
          data-testId="cancel-button"
          title={translate(messages.cancel, props)}
        />
        <PrimaryButton
          onClick={handleValidate}
          disableElevation
          data-testId="validate-button"
          className="primary-button"
          title={translate(messages.confirm, props)}
          disabled={false}
        />
      </DialogActions>
    </StyledDialog>
  );
};

export default injectIntl(TutorInfoDialog);
